import React from 'react';
import { Skeleton } from '@mui/material';
import {
  SkeletonItemContainer,
  SkeletonTextContainer,
} from './conversation-items-skeleton.styled';

const ConversationItemSkeleton = (): JSX.Element => {
  return (
    <>
      <SkeletonItemContainer>
        <Skeleton variant="circular" animation="wave" width={ 40 } height={ 40 } />
        <SkeletonTextContainer>
          <Skeleton variant="text" animation="wave" width="80%" height={ 20 } />
          <Skeleton variant="text" animation="wave" width="60%" height={ 16 } />
        </SkeletonTextContainer>
      </SkeletonItemContainer>
      <SkeletonItemContainer>
        <Skeleton variant="circular" animation="wave" width={ 40 } height={ 40 } />
        <SkeletonTextContainer>
          <Skeleton variant="text" animation="wave" width="80%" height={ 20 } />
          <Skeleton variant="text" animation="wave" width="60%" height={ 16 } />
        </SkeletonTextContainer>
      </SkeletonItemContainer>
    </>
  );
};

export default ConversationItemSkeleton;
